import React, { useState, useEffect } from 'react'
import styles from './AnswerStateIcon.module.scss'
import {
  faHourglassHalf,
  faCheck,
  faPencilAlt,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IOpenEnded {
  state: number
}

const GetStateIcon: React.FC<IOpenEnded> = ({ state }) => {
  const [selectedState, setSelectedState] = useState({
    class: 'success',
    icon: faCheck,
  } as any)

  useEffect(() => {
    setSelectedState(init(state))
  }, [state])

  const init = (currentState: number) => {
    switch (currentState) {
      case 1:
        return { class: 'typing', icon: faPencilAlt }
      case 2:
        return { class: 'sending', icon: faHourglassHalf }
        break
      case 3:
        return { class: 'success', icon: faCheck }
      default:
        return { class: 'success', icon: faCheck }
    }
  }

  return (
    <>
      {state !== 0 ? (
        <div className={`${styles.onCircle} ${styles[selectedState.class]} `}>
          {<FontAwesomeIcon icon={selectedState && selectedState.icon} />}
        </div>
      ) : (
        <div className={styles.nonDisplay}></div>
      )}
    </>
  )
}

export default GetStateIcon
